/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Box, Button, IconButton, styled, Typography } from "@mui/material";
import { fonts } from "../../themes/dashboard";

export const AdminDialogPaperProps = {
  sx: {
    borderRadius: "12px",
    display: "flex",
    flexDirection: "column",
    maxHeight: "90vh",
    overflow: "hidden",
    padding: 0,
  },
};

export const scrollableContent = {
  padding: "0px",
  overflowY: "auto",
};

export const TitleContainer = styled(Box)({
  alignItems: "center",
  borderBottom: "1px solid #e4e4e7",
  display: "flex",
  justifyContent: "space-between",
  padding: "16px 24px",
});

export const TitleText = styled(Typography)({
  color: "#18181b",
  fontFamily: fonts?.fontFamily,
  fontSize: "18px",
  fontWeight: "600",
  letterSpacing: "0px",
});

export const CloseIconButton = styled(IconButton)({
  color: "#71717a",
  padding: "4px",
  "&:hover": {
    color: "#18181b",
  },
});

export const SectionContainer = styled(Box)({
  borderBottom: "1px solid #e4e4e7",
  padding: "20px 24px",
  "&:last-of-type": {
    borderBottom: "none",
  },
});

export const FieldContainer = styled(Box)({
  marginBottom: "14px",
  "&:last-of-type": {
    marginBottom: "0px",
  },
});

export const FieldLabel = styled("label")({
  alignItems: "center",
  color: "#3f3f46",
  display: "flex",
  fontFamily: fonts?.fontFamily,
  fontSize: "13px",
  fontWeight: "600",
  marginBottom: "6px",
});

export const RequiredMark = styled("span")({
  color: "#d32f2f",
  marginLeft: "3px",
});

// Holds the same height the form would occupy, so the modal does not resize under the admin when
// the record it is fetching arrives.
export const LoadingContainer = styled(Box)({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  minHeight: "320px",
});

export const FixedActionContainer = styled(Box)({
  alignItems: "center",
  backgroundColor: "#ffffff",
  borderTop: "1px solid #e4e4e7",
  display: "flex",
  gap: "10px",
  justifyContent: "flex-end",
  padding: "14px 24px",
});

export const SaveButton = styled(Button)({
  "&.Mui-disabled": {
    backgroundColor: "#e0e0e0",
  },
  "&:hover": {
    backgroundColor: "#395bbd",
    boxShadow: "none",
  },
  backgroundColor: "#395bbd",
  boxShadow: "none",
  borderRadius: "8px",
  fontSize: "13px",
  fontWeight: "600",
  height: "35px",
  minWidth: "120px",
  padding: "0px 15px",
  textTransform: "none",
});

export const tooltipIconStyle = { fontSize: "15px", marginLeft: "5px" };

export const topLevelMenuProps = {
  PaperProps: {
    style: {
      maxHeight: "40vh",
      width: 250,
    },
  },
};
